import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, Validators, AbstractControl, FormBuilder } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApproveConfigService } from '../approve-config.service';
import { ConfigureVM, ResourceConfigurationDto, JobConfigurationDto } from '../../../Models/ApprovalQueueConfigVm';


@Component({
  selector: 'app-add-configuration',
  templateUrl: './addConfiguration.component.html',
  styleUrls: ['./addConfiguration.component.scss']
})

export class AddConfigurationComponent implements OnInit {
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public restService: ApproveConfigService) { }

  loggedinUser: any;
  buttonText: string;
  formGroup = this.formBuilder.group({});
  resEditLink: boolean = false;
  jobEditLink: boolean = false;
  dirtyFlag: boolean = false;
  dropdownSettings: IDropdownSettings = {};
  dropDownData;
  userConfig: ConfigureVM;
  config: ConfigureVM;
  SaveErrorMessage: string = '';
  customResultId: number;
  //Edit Configuration
  resEditSubAreaList = [];
  resEditSubAreaSelectedItems = [];
  resEditManageCountryList = [];
  resEditLocationList = [];
  resEditServiceLineList = [];
  resEditSubServiceLineList = [];

  resEditDepartmentList = [];
  resEditGdsRegionAlignment = [];
  resEditCostCenterList = [];
    //GFIS
  resEditCompanyCodeList = [];
  resEditEconomicLocationList = [];
  resEditCompetencyList = [];
  resEditActivityTypeList = [];
  jobEditManageCountryList = [];
  jobEditServiceLineList = [];
  jobEditSubServiceLineList = [];
  jobEditJobCategoryList = [];
  jobEditJobCodeList = [];
  //GFIS
  jobEditCompanyCodeList = [];
  jobEditEconomicLocationList = [];
  jobEditCompetencyList = [];
  //GFIS
  resEditCompanyCodeSelectedItems = [];
  resEditEconomicLocationSelectedItems = [];
  resEditCompetencySelectedItems = [];
  resEditActivityTypeSelectedItems = [];

  resEditManageCountrySelectedItems = [];
  resEditLocationSelectedItems = [];
  resEditServiceLineSelectedItems = [];
  resEditSubServiceLineSelectedItems = [];
  resEditDepartmentSelectedItems = [];
  resEditGdsRegionAlignmentSelectedItems = [];
  resEditCostCenterSelectedItems = [];

  //GFIS
  jobEditCompanyCodeSelectedItems = [];
  jobEditEconomicLocationSelectedItems = [];
  jobEditCompetencySelectedItems = [];

  jobEditManageCountrySelectedItems = [];
  jobEditServiceLineSelectedItems = [];
  jobEditSubServiceLineSelectedItems = [];
  jobEditJobCategorySelectedItems = [];
  jobEditJobCodeSelectedItems = [];


  ngOnInit(): void {
    this.loggedinUser = JSON.parse(sessionStorage.getItem('resource'));
    this.buttonText = 'Apply';
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
    this.getInitialData();
    //this.masterData();
    this.restService.configureEvent.subscribe((data) => {
      console.log('configure', data);
    });
  }
  getInitialData() {
    this.spinner.show();
    this.restService.getData().subscribe(res => {
      this.dropDownData = res[1];
      this.userConfig = res[0];
      this.config = res[0];
      this.setData();
      console.log('useConfig', this.config);
    })
  }
  setData() {
    let resList = this.dropDownData.userApproverResConfigurationDto;
    let jobList = this.dropDownData.userApproverJobConfigurationDto;

    if (resList.ResViewManagerialCountries != null) {
      resList.ResViewManagerialCountries.forEach((element) => {
        this.resEditManageCountryList =
          this.resEditManageCountryList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if (resList.ResViewCompanyCodes != null) {
      resList.ResViewCompanyCodes.forEach((element) => {
        this.resEditCompanyCodeList =
          this.resEditCompanyCodeList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }


    if (resList.ResViewEconomicLocations != null) {
      resList.ResViewEconomicLocations.forEach((element) => {
        this.resEditEconomicLocationList =
          this.resEditEconomicLocationList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    if (resList.ResViewOfficeLocations != null) {
      resList.ResViewOfficeLocations.forEach((element) => {
        this.resEditLocationList =
          this.resEditLocationList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if (resList.ResViewServiceLines != null) {
      resList.ResViewServiceLines.forEach((element) => {
        this.resEditServiceLineList =
          this.resEditServiceLineList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if (resList.ResViewSubServiceLines != null) {
      resList.ResViewSubServiceLines.forEach((element) => {
        this.resEditSubServiceLineList =
          this.resEditSubServiceLineList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    
    if (resList.ResViewActivityTypes != null) {
      resList.ResViewActivityTypes.forEach((element) => {
        this.resEditActivityTypeList =
          this.resEditActivityTypeList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    if (resList.ResViewDepartments != null) {
      resList.ResViewDepartments.forEach((element) => {
        this.resEditDepartmentList =
          this.resEditDepartmentList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if (resList.ResViewGDSRegionAlignments != null) {
      resList.ResViewGDSRegionAlignments.forEach((element) => {
        this.resEditGdsRegionAlignment =
          this.resEditGdsRegionAlignment.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if (resList.ResViewResourceCostCenters != null) {
      resList.ResViewResourceCostCenters.forEach((element) => {
        this.resEditCostCenterList =
          this.resEditCostCenterList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    if (resList.ResViewCompetencies != null) {
      resList.ResViewCompetencies.forEach((element) => {
        this.resEditCompetencyList =
          this.resEditCompetencyList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    if (jobList.JobViewManagerialCountries != null) {
      jobList.JobViewManagerialCountries.forEach((element) => {
        this.jobEditManageCountryList =
          this.jobEditManageCountryList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    
    if (jobList.JobViewCompanyCodes != null) {
      jobList.JobViewCompanyCodes.forEach((element) => {
        this.jobEditCompanyCodeList =
          this.jobEditCompanyCodeList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    if (jobList.JobViewEconomicLocations != null) {
      jobList.JobViewEconomicLocations.forEach((element) => {
        this.jobEditEconomicLocationList =
          this.jobEditEconomicLocationList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    
    if (jobList.JobViewServiceLines != null) {
      jobList.JobViewServiceLines.forEach((element) => {
        this.jobEditServiceLineList =
          this.jobEditServiceLineList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if (jobList.JobViewSubServiceLines != null) {
      jobList.JobViewSubServiceLines.forEach((element) => {
        this.jobEditSubServiceLineList =
          this.jobEditSubServiceLineList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    if (jobList.JobViewCompetencies != null) {
      jobList.JobViewCompetencies.forEach((element) => {
        this.jobEditCompetencyList =
          this.jobEditCompetencyList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }

    
    if (jobList.JobViewJobCategories != null) {
      jobList.JobViewJobCategories.forEach((element) => {
        this.jobEditJobCategoryList =
          this.jobEditJobCategoryList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if (jobList.JobViewJobTypes != null) {
      jobList.JobViewJobTypes.forEach((element) => {
        this.jobEditJobCodeList =
          this.jobEditJobCodeList.concat({
            Id: element.ID,
            Text: element.Text,
          });
      });
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewManagerialCountries !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewManagerialCountries.forEach((element) => {
        this.resEditManageCountrySelectedItems = this.resEditManageCountrySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewCompanyCodes !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewCompanyCodes.forEach((element) => {
        this.resEditCompanyCodeSelectedItems = this.resEditCompanyCodeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverResConfigurationDto.ResViewOfficeLocations !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewOfficeLocations.forEach((element) => {
        this.resEditLocationSelectedItems = this.resEditLocationSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewServiceLines !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewServiceLines.forEach((element) => {
        this.resEditServiceLineSelectedItems = this.resEditServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewSubServiceLines !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewSubServiceLines.forEach((element) => {
        this.resEditSubServiceLineSelectedItems = this.resEditSubServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    

    if(this.userConfig.userApproverResConfigurationDto.ResViewActivityTypes !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewActivityTypes.forEach((element) => {
        this.resEditActivityTypeSelectedItems = this.resEditActivityTypeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverResConfigurationDto.ResViewEconomicLocations !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewEconomicLocations.forEach((element) => {
        this.resEditEconomicLocationSelectedItems = this.resEditEconomicLocationSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewDepartments !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewDepartments.forEach((element) => {
        this.resEditDepartmentSelectedItems = this.resEditDepartmentSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewGDSRegionAlignments !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewGDSRegionAlignments.forEach((element) => {
        this.resEditGdsRegionAlignmentSelectedItems = this.resEditGdsRegionAlignmentSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewResourceCostCenters !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewResourceCostCenters.forEach((element) => {
        this.resEditCostCenterSelectedItems = this.resEditCostCenterSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewCompetencies !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewCompetencies.forEach((element) => {
        this.resEditCompetencySelectedItems = this.resEditCompetencySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverJobConfigurationDto.JobViewManagerialCountries !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewManagerialCountries.forEach((element) => {
        this.jobEditManageCountrySelectedItems = this.jobEditManageCountrySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverJobConfigurationDto.JobViewCompanyCodes !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewCompanyCodes.forEach((element) => {
        this.jobEditCompanyCodeSelectedItems = this.jobEditCompanyCodeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverJobConfigurationDto.JobViewEconomicLocations !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewEconomicLocations.forEach((element) => {
        this.jobEditEconomicLocationSelectedItems = this.jobEditEconomicLocationSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }


    if(this.userConfig.userApproverJobConfigurationDto.JobViewCompanyCodes !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewCompanyCodes.forEach((element) => {
        this.jobEditCompanyCodeSelectedItems = this.jobEditCompanyCodeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverJobConfigurationDto.JobViewServiceLines !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewServiceLines.forEach((element) => {
        this.jobEditServiceLineSelectedItems = this.jobEditServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverJobConfigurationDto.JobViewSubServiceLines !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewSubServiceLines.forEach((element) => {
        this.jobEditSubServiceLineSelectedItems = this.jobEditSubServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

   if(this.userConfig.userApproverJobConfigurationDto.JobViewCompetencies !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewCompetencies.forEach((element) => {
        this.jobEditCompetencySelectedItems = this.jobEditCompetencySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverJobConfigurationDto.JobViewJobCategories !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewJobCategories.forEach((element) => {
        this.jobEditJobCategorySelectedItems = this.jobEditJobCategorySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverJobConfigurationDto.JobViewJobTypes !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewJobTypes.forEach((element) => {
        this.jobEditJobCodeSelectedItems = this.jobEditJobCodeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    this.resEditLink = this.userConfig.UA_R_Link;
    this.jobEditLink = this.userConfig.UA_J_Link;
    this.spinner.hide();
  }
  makeDirty() {
    if (!this.dirtyFlag) {
      this.dirtyFlag = true;
    }
  }


  ClearAllSelectdVals(){
    this.dirtyFlag=true;
    this.resEditLink = this.userConfig?.UA_R_Link;
    this.jobEditLink = this.userConfig?.UA_J_Link;
    this.resEditCompanyCodeSelectedItems = [];
    this.resEditCompetencySelectedItems = [];
    this.resEditEconomicLocationSelectedItems = [];
    this.resEditActivityTypeSelectedItems = [];

    this.resEditManageCountrySelectedItems = [];
    this.resEditLocationSelectedItems = [];
    this.resEditServiceLineSelectedItems = [];
    this.resEditSubServiceLineSelectedItems = [];
    this.resEditDepartmentSelectedItems = [];
    this.resEditGdsRegionAlignmentSelectedItems = [];
    this.resEditCostCenterSelectedItems = [];
    this.jobEditManageCountrySelectedItems = [];
    this.jobEditEconomicLocationSelectedItems = [];
    this.jobEditCompanyCodeSelectedItems = [];
    this.jobEditServiceLineSelectedItems = [];
    this.jobEditSubServiceLineSelectedItems = [];
    this.jobEditCompetencySelectedItems = [];
    this.jobEditJobCategorySelectedItems = [];
    this.jobEditJobCodeSelectedItems = [];
  }

  clearForm() {
    this.resEditLink = this.userConfig.UA_R_Link;
    this.jobEditLink = this.userConfig.UA_J_Link;
    this.resEditManageCountrySelectedItems = [];
    this.resEditCompanyCodeSelectedItems = [];
    this.resEditCompetencySelectedItems = [];
    this.resEditEconomicLocationSelectedItems = [];
    this.resEditActivityTypeSelectedItems = [];
    this.resEditLocationSelectedItems = [];
    this.resEditServiceLineSelectedItems = [];
    this.resEditSubServiceLineSelectedItems = [];
    this.resEditDepartmentSelectedItems = [];
    this.resEditGdsRegionAlignmentSelectedItems = [];
    this.resEditCostCenterSelectedItems = [];
    this.jobEditManageCountrySelectedItems = [];
    this.jobEditEconomicLocationSelectedItems = [];
    
    this.jobEditCompanyCodeSelectedItems = [];
    this.jobEditServiceLineSelectedItems = [];
    this.jobEditSubServiceLineSelectedItems = [];
    this.jobEditCompetencySelectedItems = [];
    this.jobEditJobCategorySelectedItems = [];
    this.jobEditJobCodeSelectedItems = [];
    if(this.userConfig.userApproverResConfigurationDto.ResViewManagerialCountries !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewManagerialCountries.forEach((element) => {
        this.resEditManageCountrySelectedItems = this.resEditManageCountrySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewCompanyCodes !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewCompanyCodes.forEach((element) => {
        this.resEditCompanyCodeSelectedItems = this.resEditCompanyCodeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewEconomicLocations !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewEconomicLocations.forEach((element) => {
        this.resEditEconomicLocationSelectedItems = this.resEditEconomicLocationSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewOfficeLocations !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewOfficeLocations.forEach((element) => {
        this.resEditLocationSelectedItems = this.resEditLocationSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewServiceLines !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewServiceLines.forEach((element) => {
        this.resEditServiceLineSelectedItems = this.resEditServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewSubServiceLines !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewSubServiceLines.forEach((element) => {
        this.resEditSubServiceLineSelectedItems = this.resEditSubServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }


     if(this.userConfig.userApproverResConfigurationDto.ResViewActivityTypes !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewActivityTypes.forEach((element) => {
        this.resEditActivityTypeSelectedItems = this.resEditActivityTypeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }


    if(this.userConfig.userApproverResConfigurationDto.ResViewDepartments !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewDepartments.forEach((element) => {
        this.resEditDepartmentSelectedItems = this.resEditDepartmentSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewGDSRegionAlignments !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewGDSRegionAlignments.forEach((element) => {
        this.resEditGdsRegionAlignmentSelectedItems = this.resEditGdsRegionAlignmentSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverResConfigurationDto.ResViewResourceCostCenters !=null){
      this.userConfig.userApproverResConfigurationDto.ResViewResourceCostCenters.forEach((element) => {
        this.resEditCostCenterSelectedItems = this.resEditCostCenterSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverJobConfigurationDto.JobViewManagerialCountries !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewManagerialCountries.forEach((element) => {
        this.jobEditManageCountrySelectedItems = this.jobEditManageCountrySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverJobConfigurationDto.JobViewEconomicLocations !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewEconomicLocations.forEach((element) => {
        this.jobEditEconomicLocationSelectedItems = this.jobEditEconomicLocationSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    

    if(this.userConfig.userApproverJobConfigurationDto.JobViewCompanyCodes !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewCompanyCodes.forEach((element) => {
        this.jobEditCompanyCodeSelectedItems = this.jobEditCompanyCodeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverJobConfigurationDto.JobViewServiceLines !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewServiceLines.forEach((element) => {
        this.jobEditServiceLineSelectedItems = this.jobEditServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverJobConfigurationDto.JobViewSubServiceLines !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewSubServiceLines.forEach((element) => {
        this.jobEditSubServiceLineSelectedItems = this.jobEditSubServiceLineSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverJobConfigurationDto.JobViewCompetencies !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewCompetencies.forEach((element) => {
        this.jobEditCompetencySelectedItems = this.jobEditCompetencySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }

    if(this.userConfig.userApproverJobConfigurationDto.JobViewJobCategories !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewJobCategories.forEach((element) => {
        this.jobEditJobCategorySelectedItems = this.jobEditJobCategorySelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    if(this.userConfig.userApproverJobConfigurationDto.JobViewJobTypes !=null){
      this.userConfig.userApproverJobConfigurationDto.JobViewJobTypes.forEach((element) => {
        this.jobEditJobCodeSelectedItems = this.jobEditJobCodeSelectedItems.concat({
          Id: element.ID,
          Text: element.Text,
        });
      })
    }
    this.SaveErrorMessage = '';
    this.dirtyFlag = false;

  }
  onSubmit() {
    if (!this.dirtyFlag) {
      window.scroll(0, 0);
      return;
    }
    this.spinner.show();
    this.buttonText = 'Please wait..';
    //this.config = new ConfigureVM();
    let resViewDto = new ResourceConfigurationDto();
    let jobViewDto = new JobConfigurationDto();
    this.config.UA_J_Link = this.jobEditLink;
    this.config.UA_R_Link = this.resEditLink;
    // this.config.UA_CreatedBy = +sessionStorage.getItem('loggedin_resourceid');
    resViewDto.ResViewManagerialCountries = this.resEditManageCountrySelectedItems;
   
    resViewDto.ResViewOfficeLocations = this.resEditLocationSelectedItems;
    resViewDto.ResViewServiceLines = this.resEditServiceLineSelectedItems;
    resViewDto.ResViewSubServiceLines = this.resEditSubServiceLineSelectedItems;
    //GIFS
   resViewDto.ResViewEconomicLocations = this.resEditEconomicLocationSelectedItems;
   resViewDto.ResViewCompanyCodes = this.resEditCompanyCodeSelectedItems;
   resViewDto.ResViewCompetencies = this.resEditCompetencySelectedItems;
   resViewDto.ResViewActivityTypes = this.resEditActivityTypeSelectedItems;

   
    resViewDto.ResViewDepartments = this.resEditDepartmentSelectedItems;
    resViewDto.ResViewGDSRegionAlignments = this.resEditGdsRegionAlignmentSelectedItems;
    resViewDto.ResViewResourceCostCenters = this.resEditCostCenterSelectedItems;
    jobViewDto.JobViewManagerialCountries = this.jobEditManageCountrySelectedItems;
    jobViewDto.JobViewEconomicLocations = this.jobEditEconomicLocationSelectedItems;
  

    jobViewDto.JobViewCompanyCodes = this.jobEditCompanyCodeSelectedItems;
    jobViewDto.JobViewServiceLines = this.jobEditServiceLineSelectedItems;
    jobViewDto.JobViewSubServiceLines = this.jobEditSubServiceLineSelectedItems;
    jobViewDto.JobViewCompetencies = this.jobEditCompetencySelectedItems;
    jobViewDto.JobViewJobCategories = this.jobEditJobCategorySelectedItems;
    jobViewDto.JobViewJobTypes = this.jobEditJobCodeSelectedItems;

    this.config.userApproverJobConfigurationDto = jobViewDto;
    this.config.userApproverResConfigurationDto = resViewDto;

    this.restService.saveApprovalQueueConfig(this.config).subscribe(
      (data) => {
        if (data != null) {
          if (data.customResultId <= 0)
          {
            this.SaveErrorMessage = data.customException;
            this.customResultId = data.customResultId;
            window.scroll(0, 0);
          } else {
            this.config.UA_ID = data.customResultId;
            this.buttonText = 'Applied';
            this.customResultId = null;
            this.config.Message = 'Approval Queue configuration submitted successfully';
            this.restService.closeModal(true);
          }
          window.scroll(0, 0);
        }
      },
      (err) => {
        this.buttonText = 'Error';
      },
      () => {
        this.spinner.hide();
        setTimeout(() => {
          this.buttonText = 'Apply';
          setTimeout(() => {
            this.SaveErrorMessage = '';
          }, 5000);
        }, 2000);
      }
    );
  }
}
